"use client";

import NextTopLoader from "nextjs-toploader";
import { useTheme } from "next-themes";
import { startTransition, useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export default function ThemeAwareTopLoader() {
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const pathname = usePathname();
  const isSalesAgentPage = pathname.includes("/sales-agent");

  useEffect(() => {
    startTransition(() => {
      setMounted(true);
    });
  }, []);

  if (!mounted) {
    return <NextTopLoader color='#0B0B0B' height={3} showSpinner={false} crawlSpeed={200} initialPosition={0.08} />;
  }

  return (
    <NextTopLoader
      color={isSalesAgentPage ? "#2FB3FF" : theme === "dark" ? "#FAFAFA" : "#0B3B66"}
      height={3}
      showSpinner={false}
      crawlSpeed={200}
      initialPosition={0.08}
    />
  );
}
